// src/components/common/LightTooltip.jsx
import React from 'react';
import { Tooltip, useTheme } from '@mui/material';

export default function LightTooltip({ children, componentsProps, ...props }) {
  const theme = useTheme();
  return (
    <Tooltip
      {...props}
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: 'background.paper',
            color: 'text.primary',
            boxShadow: theme.shadows[4],
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: 1.5,
            p: 0,
          },
          ...componentsProps?.tooltip,
        },
        arrow: {
          sx: {
            color: 'background.paper',
            '&::before': {
              border: `1px solid ${theme.palette.divider}`,
            },
          },
          ...componentsProps?.arrow,
        },
      }}
    >
      {children}
    </Tooltip>
  );
}
